// src/constants/index.ts

// Step numbers for different stages in the deposit process
export const STEPS = {
  INITIAL: 0,
  DEPOSIT_TYPE_SELECTION: 1,
  COMPANY_SELECTION: 2,
  PHONE_ENTRY: 3,
  OTP_ENTRY: 4,
  BARCODE_ENTRY: 5,
  LOCKER_SELECTION: 6,
  PERSONAL_LOCKER_SELECTION: 7,
  RECIPIENT_PHONE_ENTRY: 71,
  PAYMENT: 8,
  DEPOSIT_COMPLETE: 9,
  COLLECT_PHONE_ENTRY: 11,
  COLLECT_OTP_ENTRY: 12,
  COLLECT_PAYMENT: 121,
  COLLECT_PAYPAL: 122,
  COLLECT_TERMINAL: 123,
  COLLECT_COMPLETE: 13,
  DROPOFF_START: 30,
  DROPOFF_PHONE: 31,
  DROPOFF_BARCODE: 32,
  DROPOFF_OTP: 33,
  DROPOFF_PAYMENT: 34,
  DROPOFF_PAYPAL: 35,
  DROPOFF_POS: 36,
  DROPOFF_DETAILS: 37,
  DROPOFF_DEPOSIT: 38,
  DROPOFF_COMPLETE: 39,
  SIMULATOR: 99,
};

// Minimum length for a valid phone number
export const MIN_PHONE_LENGTH = 9;

// Maximum length for a valid OTP
export const MAX_OTP_LENGTH = 6;

// Valid barcode length
export const VALID_BARCODE_LENGTH = 14;

// Default hold time in days
export const DEFAULT_HOLD_TIME = 3;

// Maximum number of OTP attempts
export const MAX_OTP_ATTEMPTS = 3;

// Time in milliseconds to wait before allowing another OTP request
export const OTP_RESEND_DELAY = 60000; // 1 minute

// Default currency
export const DEFAULT_CURRENCY = 'KM';

// Maximum amount of time (in milliseconds) to wait for API responses
export const API_TIMEOUT = 10000; // 10 seconds

// Mapping of locker sizes to their capacity in liters
export const LOCKER_SIZE_CAPACITY = {
  Small: 20,
  Medium: 50,
  Large: 100,
};

// Mapping of locker types to their price multipliers
export const LOCKER_TYPE_PRICE_MULTIPLIER = {
  Regular: 1,
  Refrigerated: 1.5,
  'High-Security': 2,
};

// Base price per day for a small, regular locker
export const BASE_PRICE_PER_DAY = 1.5;

// Maximum hold time in days
export const MAX_HOLD_TIME = 30;

// Error messages
export const ERROR_MESSAGES = {
  INVALID_PHONE: 'Please enter a valid phone number.',
  INVALID_OTP: 'Invalid OTP. Please try again.',
  INVALID_BARCODE: 'Invalid barcode. Please try again.',
  LOCKER_ASSIGNMENT_FAILED: 'Failed to assign a locker. Please try again.',
  PAYMENT_FAILED: 'Payment failed. Please try again.',
  NETWORK_ERROR: 'Network error. Please check your connection and try again.',
  GENERIC_ERROR: 'An error occurred. Please try again.',
};

// Success messages
export const SUCCESS_MESSAGES = {
  DEPOSIT_COMPLETE: 'Deposit complete. Thank you for using our service.',
  COLLECTION_COMPLETE: 'Collection complete. Thank you for using our service.',
};

// API endpoints
export const API_ENDPOINTS = {
  VERIFY_PHONE: '/verify-phone',
  SEND_OTP: '/send-otp',
  VERIFY_OTP: '/verify-otp',
  GET_PARCEL_DATA: '/parcel',
  ASSIGN_LOCKER: '/assign-locker',
  CALCULATE_AMOUNT: '/calculate-amount',
  GET_COMPANIES: '/companies',
};
